export default "__VITE_ASSET__CmNwihG2__"